import React, { useState, useEffect } from 'react';
import { Select, message } from 'antd'

const { Option } = Select 
const axios = require("axios");

/**
 * @const SelectAlmacen
 * @description Select para los alamcenes registrados en el sistema, relacionados a un proyecto
 */
const SelectAlmacen = (props) => {

    const { 
        value, 
        onChange, 
        placeholder = "Seleccione el almacén", 
        onSelect = () => {}, 
        disabled = false, 
        className = "", 
        params = {}, 
        bordered, 
        allowClear = true, 
        onClear = () => {},
        proyecto_id,
        mode = null
    } = props

    const [ almacenes, setAlmacenes ] = useState({
        data: [],
        page: 1,
        limit: 10,
        total: 0,
        search: null,
    })


    /**
     * @const getAlmacenes
     * @description Obitiene los inmubeles relacionados a un proyecto
     */
    const getAlmacenes = ({
        page, 
        limit, 
        search, 
        proyecto_id = props.proyecto_id
    } = almacenes) => {

        axios.get('/almacenes', {
            params: {
                page,
                limit,
                search,
                proyecto_id,
                ...params,
            },
            headers: { Authorization: sessionStorage.getItem('token') }
        }).then(({ data }) => {
            setAlmacenes(data)
        }).catch(error => {
            console.log("ERR, error",error)
            message.error(error?.response?.data?.message ?? 'Error al obtener los almacenes')
        })
    }

    //componentDidMount
    useEffect(() => {
        if(proyecto_id)
            getAlmacenes()
    }, [proyecto_id])

    useEffect(() => {
        onChange(value?.value ?? value)
    }, [value])

    return (
        <Select
            bordered={bordered}
            className={className}
            disabled={disabled}
            placeholder={placeholder}
            allowClear={allowClear}
            showSearch
            filterOption={false}
            labelInValue
            mode={mode}
            onSearch={(search)=> getAlmacenes({search})}
            onSelect={(almacen)=> {
                if(mode === null){
                    onChange(almacen.value)
                    onSelect(almacen.value)
                }
            }}
            onChange={(values)=>{
                if(mode === "multiple"){
                    let arr = values.map(e => e.value)
                    onChange(arr)
                    onSelect(arr)
                }
            }}
            value={value}
            onClear={()=>{
                onClear()
                onChange(undefined)
                onSelect(undefined)
            }}
        >
            {
                almacenes?.data?.map(({ _id, nombre }) => <Option value={_id}>{nombre ?? ""} {}</Option>)
            }
        </Select>
    );
}



export default SelectAlmacen;